<template>
  <BContainer
    v-if="currentUser"
    class="mb-4"
  >
    <div class="d-flex justify-content-end">
      <BBreadcrumb
        v-if="$route.meta.breadcrumb"
        :items="$route.meta.breadcrumb || []"
      />
    </div>

    <BSidebar
      id="sbRsmReportCustomers"
      backdrop-variant="dark"
      backdrop
      shadow
      right
    >
      <template #title>
        <i class="fad fa-filter-list" /> Filters
      </template>

      <BContainer>
        <BRow>
          <BCol
            cols="12"
          >
            <BFormGroup
              label="Month"
              label-for="filterMonth"
              label-class="font-weight-bolder"
              class="mb-2"
            >
              <flat-pickr
                id="filterMonth"
                v-model="tableRecordings.filter.month"
                class="form-control"
                placeholder="--------- ----"
                :config="flatPickerConfig"
              />
            </BFormGroup>
          </BCol>
          <BCol
            cols="12"
          >
            <BFormGroup
              label="Area"
              label-for="filterArea"
              label-class="font-weight-bolder"
              class="mb-2"
            >
              <VSelect
                v-model="tableRecordings.selected.area"
                placeholder="filter area here"
                input-id="filterArea"
                label="area_name"
                class="border border-light rounded-lg"
                clearable
                append-to-body
                :options="(tableRecordings.options.areas)"
                :loading="(tableRecordings.fetching.areas)"
                :disabled="(tableRecordings.busy || tableRecordings.fetching.areas)"
                :calculate-position="calculateDropPosition"
                @search="searchFilterAreas"
              >
                <template #no-options="">
                  no available area
                </template>
              </VSelect>
            </BFormGroup>
          </BCol>
          <BCol
            cols="12"
          >
            <BFormGroup
              label="Cluster"
              label-for="filterCluster"
              label-class="font-weight-bolder"
              class="mb-2"
            >
              <VSelect
                v-model="tableRecordings.selected.cluster"
                placeholder="filter cluster here"
                input-id="filterCluster"
                label="cluster_name"
                class="border border-light rounded-lg"
                clearable
                append-to-body
                :options="(tableRecordings.options.clusters)"
                :loading="(tableRecordings.fetching.clusters)"
                :disabled="(tableRecordings.busy || tableRecordings.fetching.clusters)"
                :calculate-position="calculateDropPosition"
                @search="searchFilterClusters"
              >
                <template #no-options="">
                  no available cluster
                </template>
              </VSelect>
            </BFormGroup>
          </BCol>
          <BCol
            cols="12"
          >
            <BFormGroup
              label="Officer"
              label-for="filterOfficer"
              label-class="font-weight-bolder"
              class="mb-2"
            >
              <VSelect
                v-model="tableRecordings.selected.fsOfficer"
                placeholder="filter officer here"
                input-id="filterOfficer"
                label="officer_name"
                clearable
                append-to-body
                :options="(tableRecordings.options.fsOfficers)"
                :loading="(tableRecordings.fetching.fsOfficers)"
                :disabled="(tableRecordings.busy || tableRecordings.fetching.fsOfficers)"
                :calculate-position="calculateDropPosition"
                @search="searchFilterFSOfficers"
              >
                <template #option="{ officer_name, mobile_number, photos }">
                  <div class="d-flex flex-column flex-md-row py-1">
                    <div class="flex-grow-1 d-flex align-items-center">
                      <div class="mr-2">
                        <BAvatar
                          v-if="photos && photos.length > 0"
                          :src="getCustomerProfile(photos)"
                          variant="primary"
                          size="28px"
                        />
                        <BAvatar
                          v-else
                          :text="String(officer_name).charAt(0)"
                          variant="primary"
                          size="28px"
                        />
                      </div>
                      <div class="d-flex flex-column">
                        <div
                          class="text-break text-wrap"
                          v-text="officer_name"
                        />
                        <strong>{{ mobile_number || '' }}</strong>
                      </div>
                    </div>
                  </div>
                </template>
                <template #selected-option="{ officer_name, photos }">
                  <div class="d-flex flex-column flex-md-row">
                    <div class="flex-grow-1 d-flex align-items-center">
                      <div class="mr-2">
                        <BAvatar
                          v-if="photos && photos.length > 0"
                          :src="getCustomerProfile(photos)"
                          variant="primary"
                          size="28px"
                        />
                        <BAvatar
                          v-else
                          :text="String(officer_name).charAt(0)"
                          variant="primary"
                          size="28px"
                        />
                      </div>
                      <div
                        class="text-break text-wrap"
                        v-text="officer_name"
                      />
                    </div>
                  </div>
                </template>
                <template #no-options="">
                  no available officer
                </template>
              </VSelect>
            </BFormGroup>
          </BCol>
        </BRow>
      </BContainer>
    </BSidebar>

    <BRow
      class="py-2"
    >
      <BCol
        cols="12"
      >
        <BFormGroup
          label="Search"
          label-for="filterSearch"
          label-class="font-weight-bolder"
          class="mb-2"
        >
          <BInputGroup>
            <BFormInput
              id="filterSearch"
              v-model="tableRecordings.filter.search"
              placeholder="search here"
              autocomplete="off"
              debounce="1000"
              type="text"
            />
            <BInputGroupAppend>
              <BButton
                v-b-toggle.sbRsmReportCustomers
                variant="primary"
              >
                <i
                  v-if="[settingFilters, tableRecordings.fetching.clusters, tableRecordings.fetching.fsOfficers].some(trueOrFalse => trueOrFalse)"
                  class="fad fa-spinner fa-spin p-0"
                />
                <i
                  v-else
                  class="fad fa-filter-list"
                /> Filters
              </BButton>
            </BInputGroupAppend>
          </BInputGroup>
        </BFormGroup>
      </BCol>
      <BCol>
        <BOverlay
          rounded
          opacity="0.1"
          spinner-small
          class="d-inline"
          spinner-variant="warning"
          :show="exporter.excel.exporting"
          style="margin-bottom: 1.1px;"
        >
          <JsonExcel
            :class="[
              'btn btn-sm btn-primary', {
                'btn-outline-primary disabled': exporter.excel.exporting || !isValidForExport
              }
            ]"
            :fetch="excelProvider"
            :before-generate="onStartExcelExport"
            :before-finish="onFinishExcelExport"
            :name="excelFileName"
            :fields="exporter.excel.fields"
            :escape-csv="exporter.excel.escape"
            :type="exporter.excel.type"
            :header="exporter.excel.header"
            :footer="exporter.excel.footer"
            worksheet="Activity Recordings"
          >
            {{ exporter.excel.exporting ? 'Exporting' : 'Export As Excel' }}
          </JsonExcel>
        </BOverlay>
      </BCol>
    </BRow>

    <CustomTable
      ref="tableRecordings"
      class="mt-3"
      :provider="tableProvider"
      :fields="tableRecordings.fields"
      :filter="tableRecordings.filter"
      :filter-on="tableRecordings.filterOn"
      :sort-by="tableRecordings.sortBy"
      :sort-desc="tableRecordings.sortDesc"
      :sort-direction="tableRecordings.sortDirection"
      :total-rows="tableRecordings.totalRows"
      :current-page="tableRecordings.currentPage"
      :per-page="tableRecordings.perPage"
      :stacked="tableRecordings.stacked"
      :busy="tableRecordings.busy"
    >

      <template #cell(action)="{ item }">
        <div class="text-md-nowrap d-flex flex-column flex-md-row justify-content-center">
          <BButton
            size="sm"
            variant="warning"
            :disabled="tableRecordings.busy"
            :to="{
              name: 'asm.officers.task-events',
              params: {
                officer: item.assignee?.id || '',
                task: item.id
              }
            }"
          >
            View
          </BButton>
        </div>
      </template>

      <template #cell(status)="{ value }">
        <BBadge
          class="w-60px"
          :variant="`${customerStatus(value)}-light`"
          pill
          v-text="value"
        />
      </template>
    </CustomTable>
  </BContainer>
</template>
<script>
import QUERY from 'lodash'
import { mapGetters } from 'vuex'
import MOMENT from 'moment'
import FPMonthSelect from 'flatpickr/dist/plugins/monthSelect'
import { setTableOptions, getTableOptions } from '@/forage/audit/reports/other-events'

import MxMisc from '@/mixins/misc'
import MxFormatter from '@/mixins/formatter'
import MxImageUrl from '@/mixins/image-url'
import MAreas from '@/mixins/locations/areas'
import MClusters from '@/mixins/locations/clusters'
import MFSOfficers from '@/mixins/accounts/fsos'

import { SAuditOfficerOtherEvent } from '@/services/audit'

export default {

  name: 'VAuditOfficerReportTasks',

  mixins: [
    MAreas,
    MClusters,
    MFSOfficers,
    MxMisc,
    MxFormatter,
    MxImageUrl
  ],

  beforeRouteEnter (_to, _from, navigate) {
    getTableOptions().then(options => {
      navigate(context => {
        if (context.currentUser) {
          context.state.settings = true

          if (options) {
            const { currentPage, perPage, sortBy, sortDesc, totalRows, filter } = options

            context.tableRecordings = Object.assign(context.tableRecordings, {
              totalRows: totalRows,
              sortBy: sortBy,
              sortDesc: sortDesc,
              perPage: perPage,
              currentPage: currentPage,
              filter: {
                search: filter.search,
                month: filter.month,
                area: '',
                cluster: '',
                officer: ''
              },
              editable: {
                area: filter.area,
                cluster: filter.cluster,
                fsOfficer: filter.officer
              }
            })
          } else {
            context.tableRecordings.currentPage = 1
          }

          context.$nextTick(() => {
            context.getAreas(context.tableRecordings).finally(() => {
              if (context.tableRecordings.editable.area) {
                context.tableRecordings.selected.area = QUERY.find(context.tableRecordings.options.areas, {
                  id: context.tableRecordings.editable.area
                }) || ''

                context.tableRecordings.editable.area = ''
              } else {
                context.getClusters(context.tableRecordings).finally(() => {
                  if (context.tableRecordings.editable.cluster) {
                    context.tableRecordings.selected.cluster = QUERY.find(context.tableRecordings.options.clusters, {
                      id: context.tableRecordings.editable.cluster
                    }) || ''

                    context.tableRecordings.editable.cluster = ''
                  } else {
                    context.getFSOfficers(context.tableRecordings).finally(() => {
                      if (context.tableRecordings.editable.fsOfficer) {
                        context.tableRecordings.selected.fsOfficer = QUERY.find(context.tableRecordings.options.fsOfficers, {
                          id: context.tableRecordings.editable.fsOfficer
                        }) || ''

                        context.tableRecordings.editable.fsOfficer = ''
                      }
                    })
                  }
                })
              }

              context.state.settings = false
            })
          })
        }
      })
    })
  },

  middleware: [
    'auth',
    'audit'
  ],

  metaInfo: () => ({
    title: 'Report - Activity Recordings'
  }),

  data () {
    return {
      flatPickerConfig: {
        appendTo: document.body,
        altInput: true,
        allowInput: true,
        disableMobile: true,
        plugins: [
          new FPMonthSelect({
            dateFormat: 'Y-m',
            altFormat: 'F Y'
          })
        ]
      },
      state: {
        busy: false,
        editing: false,
        settings: false
      },
      exporter: {
        excel: {
          exporting: false,
          header: [],
          escape: false,
          type: 'xls',
          fields: {
            Month: {
              field: '',
              callback: row => `="${row.event_year}-${row.event_month}"`
            },
            Area: {
              field: 'creator.area.area_name'
            },
            Cluster: {
              field: 'creator.cluster.cluster_name'
            },
            AreaManager: {
              field: 'areaManager',
              callback: areaManager => {
                return `${areaManager?.first_name} ${areaManager?.last_name}`
              }
            },
            Officer: {
              field: 'creator',
              callback: creator => {
                return `${creator?.first_name} ${creator?.last_name}`
              }
            },
            Activity: {
              field: 'activity.activity_name'
            },
            Total: {
              field: 'total'
            },
            Province: {
              field: 'province.province_name'
            },
            Municipality: {
              field: 'municipality.municipality_name'
            },
            Barangay: {
              field: 'barangay.barangay_name'
            }
          },
          footer: []
        }
      },
      tableRecordings: {
        busy: false,
        fetching: {
          areas: false,
          clusters: false,
          fsOfficers: false
        },
        options: {
          areas: [],
          clusters: [],
          fsOfficers: []
        },
        selected: {
          area: '',
          cluster: '',
          fsOfficer: ''
        },
        editable: {
          area: '',
          cluster: '',
          fsOfficer: ''
        },
        filter: {
          search: '',
          month: MOMENT().format('YYYY-MM'),
          area: '',
          cluster: '',
          officer: ''
        },
        filterOn: [],
        stacked: 'sm',
        sortBy: 'id',
        sortDesc: false,
        sortDirection: 'asc',
        pageOptions: [10, 25, 50, 100],
        currentPage: 0,
        totalRows: 0,
        perPage: 10,
        fields: [
          { mobile: 0, key: 'index', label: '#', class: 'text-right stacked-full text-md-center' },
          {
            mobile: 1,
            key: 'event_month',
            label: 'Month',
            class: 'min-w-75px',
            formatter: (_val, _key, row) => {
              return this.monthLongFormatter(`${row.event_year}-${row.event_month}-01`)
            }
          },
          { mobile: 2, key: 'creator', label: 'Officer', class: 'min-w-md-250px', formatter: creator => this.getFullName(null, null, creator), sortable: true },
          { mobile: 3, key: 'activity.activity_name', label: 'Activity', class: 'min-w-md-250px' },
          { mobile: 4, key: 'total', label: 'Activity Count', class: 'text-center' },
          { mobile: 6, key: 'creator.area.area_name', label: 'Area', class: 'min-w-250px' },
          { mobile: 5, key: 'creator.cluster.cluster_name', label: 'Cluster', class: 'min-w-250px' },
          { mobile: 7, key: 'province.province_name', label: 'Province', class: 'min-w-200px' },
          { mobile: 8, key: 'municipality.municipality_name', label: 'Municipality', class: 'min-w-200px' },
          { mobile: 9, key: 'barangay.barangay_name', label: 'Barangay', class: 'min-w-200px' }
        ].sort(this.scaleOnMobile)
      }
    }
  },

  computed: {
    ...mapGetters({
      currentUser: 'auth/user'
    }),

    excelFileName () {
      const month = MOMENT(this.tableRecordings.filter.month).format('YYYY-MM')
      return `Activity Recordings - ${month}`
    },

    isValidForExport () {
      const isDateFromNotEmpty = ![null, '', ' '].includes(this.tableRecordings.filter.month)

      return isDateFromNotEmpty && Number(this.tableRecordings.totalRows) >= 1
    },

    settingFilters () {
      const hasEditables = Object.keys(this.tableRecordings.editable).map(
        editableKey => this.tableRecordings.editable[editableKey]
      ).some(val => String(val) !== '')

      return hasEditables
    }
  },

  watch: {
    'tableRecordings.selected.area' (area) {
      this.tableRecordings.filter.area = area?.id || ''
    },

    'tableRecordings.selected.cluster' (cluster) {
      this.tableRecordings.filter.cluster = cluster?.id || ''
    },

    'tableRecordings.selected.fsOfficer' (fsOfficer) {
      this.tableRecordings.filter.officer = fsOfficer?.id || ''
    },

    'tableRecordings.filter.area' (area) {
      this.getClusters(this.tableRecordings, '', area).finally(() => {
        if (this.tableRecordings.editable.cluster) {
          this.tableRecordings.selected.cluster = QUERY.find(this.tableRecordings.options.clusters, {
            id: this.tableRecordings.editable.cluster
          }) || ''

          this.tableRecordings.editable.cluster = ''
        } else {
          this.getFSOfficers(this.tableRecordings, '', area, this.tableRecordings.filter.cluster).finally(() => {
            if (this.tableRecordings.editable.fsOfficer) {
              this.tableRecordings.selected.fsOfficer = QUERY.find(this.tableRecordings.options.fsOfficers, {
                id: this.tableRecordings.editable.fsOfficer
              }) || ''

              this.tableRecordings.editable.fsOfficer = ''
            }
          })
        }
      })
    },

    'tableRecordings.filter.cluster' (cluster) {
      this.getFSOfficers(this.tableRecordings, '', this.currentUser.area, cluster).finally(() => {
        if (this.tableRecordings.editable.fsOfficer) {
          this.tableRecordings.selected.fsOfficer = QUERY.find(this.tableRecordings.options.fsOfficers, {
            id: this.tableRecordings.editable.fsOfficer
          }) || ''

          this.tableRecordings.editable.fsOfficer = ''
        }
      })
    }
  },

  methods: {

    customerStatus (status) {
      switch (status) {
        case 'Verified': {
          return 'secondary'
        }
        case 'New': {
          return 'primary'
        }
        default: {
          return 'warning'
        }
      }
    },

    async tableProvider ({ currentPage, perPage, sortBy, sortDesc, filter }) {
      if (this.settingFilters) {
        return []
      }

      this.tableRecordings.busy = true
      const payload = {
        page: currentPage,
        per_page: perPage,
        sort: sortBy,
        sort_desc: sortDesc,
        filter_text: filter.search,
        creator_id: filter.officer,
        area_id: filter.area,
        cluster_id: filter.cluster,
        month: ''
      }

      if (filter.month) {
        payload.month = MOMENT(filter.month).format('MM')
      }

      return await SAuditOfficerOtherEvent.reports(payload).then(
        ({ data }) => {
          this.tableRecordings.totalRows = data.total_rows
          setTableOptions({
            currentPage,
            perPage,
            sortBy,
            sortDesc,
            filter,
            totalRows: data.total_rows
          })

          return data.items
        }
      ).catch(() => {
        this.tableRecordings.totalRows = 0
        setTableOptions({
          currentPage,
          perPage,
          sortBy,
          sortDesc,
          filter,
          totalRows: 0
        })

        return []
      }).finally(() => {
        this.tableRecordings.busy = false
      })
    },

    async searchFilterAreas (search, loading) {
      this.searchAreasProvider(this.tableRecordings, search, loading)
    },

    async searchFilterClusters (search, loading) {
      this.searchClustersProvider(this.tableRecordings, search, loading)
    },

    async searchFilterFSOfficers (search, loading) {
      this.searchFSOfficersProvider(this.tableRecordings, search, loading)
    },

    async excelProvider () {
      if (this.exporter.busy || !this.isValidForExport) {
        return null
      }

      this.exporter.busy = this.exporter.excel.exporting = true

      const payload = {
        filter_text: this.tableRecordings.filter.search,
        creator_id: this.tableRecordings.filter.officer,
        area_id: this.currentUser.area,
        cluster_id: this.tableRecordings.filter.cluster,
        month: ''
      }

      if (this.tableRecordings.filter.month) {
        payload.month = MOMENT(this.tableRecordings.filter.month).format('MM')
      }

      return await SAuditOfficerOtherEvent.exports(payload).then(
        ({ data: { items } }) => {
          if (items.length <= 0) {
            this.swalInvalid(
              'No available data to be Exported'
            )
          }

          return items
        }
      ).catch(() => {
        return []
      }).finally(() => {
        this.exporter.busy = this.exporter.excel.exporting = false
      })
    },

    onStartExcelExport () {
      if (this.exporter.busy || !this.isValidForExport) {
        return null
      }

      this.exporter.excel.header = []
      this.exporter.excel.footer = []
    },

    onFinishExcelExport () {
    }
  }
}
</script>
